import { MessagePrimitive } from "@assistant-ui/react";
import { userMessageStyles as s } from "./UserMessage.styles";

export function UserMessage() {
  return (
    <MessagePrimitive.Root className={s.root}>
      <div className={s.bubble}>
        <MessagePrimitive.Parts />
      </div>
    </MessagePrimitive.Root>
  );
}
